import { createStore } from "vuex";

export default createStore({
  state: {
    keyword: "",
    page: 1,
  },
  actions: {
    setSearchData({ commit }, data) {
      this.state.keyword = data.keyword;
      this.state.page = data.page;
    },
  },
  mutations: {},
  getters: {
    getSearchKeyword(state) {
      return state.keyword;
    },
    getSearchPage(state) {
      return state.page;
    },
  },
});
